@if (adminOutdoorModules().length > 0) {
  <app-toolbar-section [label]="'Mes stations' | AsyncLang | async">
    @for (outdoorModule of adminOutdoorModules(); track outdoorModule) {
      <ng-container *ngTemplateOutlet="station; context: {outdoorModule}" />
    }
  </app-toolbar-section>
}

@if (friendOutdoorModules().length > 0) {
  <app-toolbar-section [label]="'Stations invités' | AsyncLang | async">
    @for (outdoorModule of friendOutdoorModules(); track outdoorModule) {
      <ng-container *ngTemplateOutlet="station; context: {outdoorModule}" />
    }
  </app-toolbar-section>
}

@if (favoriteOutdoorModules().length > 0) {
  <app-toolbar-section [label]="'Stations favorites' | AsyncLang | async">
    @for (outdoorModule of favoriteOutdoorModules(); track outdoorModule) {
      <ng-container *ngTemplateOutlet="station; context: {outdoorModule}" />
    }
  </app-toolbar-section>
}

<ng-template #station let-outdoorModule="outdoorModule">
  <app-station
    [outdoorModule]="outdoorModule"
    [home]="homes()[outdoorModule.homeId]"
    [station]="stations()[outdoorModule.bridge]"
    (selectStation)="selectStation($event)"/>
</ng-template>